import styled from 'styled-components';

export const Main = styled.div`
   min-width: 150px;
   padding: 0;
`;

export const Styled = styled.div`
   h3 {
      margin-bottom: 10px;
      font-size: 15px;
      font-weight: 400;
      text-align: center;

      span {
         opacity: 0.7;
      }
   }
   > div {
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: rgb(245, 245, 245);
      border: 1px solid rgb(220, 220, 220);
      border-radius: 10px;
      padding: 7.5px 15px;
      font-size: 15px;
      height: 35px;

      &:not(:last-of-type) {
         margin-bottom: 7.5px;
      }
      span:first-of-type {
         width: 10px;
         height: 10px;
         background-color: #339966;
         margin-right: 7.5px;
         border-radius: 2px;
         box-shadow: 0 0 3px #339966;
      }
      span:last-of-type {
         opacity: 0.75;
      }
   }
   .empty {
      display: block;
      opacity: 0.8;
      text-align: center;
   }
`;